import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

export function discountValidatorTravel(control: FormControl) {
    let discount = parseInt(control.value);
    
    if (discount) {
        var maxDiscount = 35;
        if(discount>maxDiscount){

            return {
                invalidDiscount : true
            }
   
        }        
     }
    return null;
}

@Directive({
    selector: '[discountValidatorTravel][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: discountValidatorTravel,
            multi: true
        }
    ]
})
export class DiscountValidatorTravel {
}